import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { useApi, errMsg } from "@/lib/api";
import { ScopePicker } from "@/components/apikeys/ScopePicker";

const EMPTY = { name: "", description: "", scopes: {}, expires_at: "", allowed_ips: "", rate_limit: 60 };

export const KeyFormDialog = ({ open, edit, modules, onClose, onSaved }) => {
  const api = useApi();
  const [f, setF] = useState(EMPTY);
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (open) { setF(edit ? { ...edit, scopes: edit.scopes || {}, rate_limit: edit.rate_limit || 60, description: edit.description || "", expires_at: edit.expires_at || "", allowed_ips: (edit.allowed_ips || []).join("\n") } : EMPTY); }
  }, [open, edit]);
  const set = (k) => (e) => setF((p) => ({ ...p, [k]: e?.target ? e.target.value : e }));
  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    const body = { name: f.name, description: f.description, scopes: f.scopes, expires_at: f.expires_at || null,
      allowed_ips: f.allowed_ips.split(/[\s,]+/).filter(Boolean), rate_limit: Number(f.rate_limit) || 60 };
    try {
      const res = edit ? await api("patch", `/api-keys/${edit.id}`, body) : await api("post", "/api-keys", body);
      toast.success(edit ? "Clé mise à jour" : "Clé créée");
      onSaved(res);
    } catch (err) { toast.error(errMsg(err)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="key-form-dialog">
        <DialogHeader>
          <DialogTitle>{edit ? "Modifier la clé" : "Nouvelle clé partenaire"}</DialogTitle>
          <DialogDescription>Choisissez précisément ce que ce partenaire peut lire ou modifier.</DialogDescription>
        </DialogHeader>
        <form onSubmit={submit} className="space-y-5">
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-1.5"><Label>Nom du partenaire *</Label><Input value={f.name} onChange={set("name")} required placeholder="Ex. Laboratoire Central" data-testid="key-name-input" /></div>
            <div className="space-y-1.5"><Label>Date d'expiration</Label><Input type="date" value={f.expires_at} onChange={set("expires_at")} data-testid="key-expiry-input" /></div>
          </div>
          <div className="space-y-1.5"><Label>Description</Label><Input value={f.description} onChange={set("description")} placeholder="Usage prévu de la clé" data-testid="key-description-input" /></div>
          <ScopePicker modules={modules} value={f.scopes} onChange={set("scopes")} />
          <div className="grid sm:grid-cols-2 gap-4">
            <div className="space-y-1.5"><Label>Limite d'appels par minute</Label><Input type="number" min={1} max={10000} value={f.rate_limit} onChange={set("rate_limit")} data-testid="key-rate-input" /></div>
            <div className="space-y-1.5"><Label>Adresses IP autorisées</Label><Textarea rows={3} value={f.allowed_ips} onChange={set("allowed_ips")} placeholder={"Vide = toutes\n41.200.10.5\n10.0.0.0/24"} data-testid="key-ips-input" /></div>
          </div>
          <div className="flex justify-end gap-2">
            <Button type="button" variant="outline" onClick={onClose} data-testid="key-form-cancel">Annuler</Button>
            <Button type="submit" disabled={busy} className="bg-[#C2410C] hover:bg-[#9A3412] text-white" data-testid="key-form-submit">{edit ? "Enregistrer" : "Créer la clé"}</Button>
          </div>
        </form>
      </DialogContent>
    </Dialog>
  );
};
